/**
 * @module tree/replaceWith
 */

/**
 * @typedef {String|Number|DocumentFragment|Element|Text} Content
 */

import fragment from './fragment.js'

/**
 * Replaces the current target by some new contents
 * @param {Document|DocumentFragment|Element} target
 * @param {...Content} contents
 */
export default (
  target,
  ...contents
) => {
  const { ownerDocument, parentNode } = target

  parentNode.replaceChild(fragment(contents, ownerDocument), target)
}
